// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ExternalProductDto extends ItiBaseDto {
	public productId: string;
	public productName: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
